@for (widget of widgetList(); track $index) {
  <div
    class="my-mobileGap tablet:my-tabletGap desktop:my-desktopGap scroll-m-44 tablet:scroll-m-48 desktop:scroll-mt-56"
    [ngClass]="{ 'mt-0 tablet:mt-0 desktop:mt-0': !firstItemMargin() }"
    [id]="'section-' + widget.data.title"
  >
    @switch (widget.type) {
      @case (widgetType.FaqWidget) {
        <sc-faq-widget [data]="widget.data"></sc-faq-widget>
      }
      @case (widgetType.LinkWidget) {
        <sc-link-widget [data]="widget.data"></sc-link-widget>
      }
      @case (widgetType.CloudStorageBannerWidget) {
        <sc-cloud-storage-banner-widget [data]="widget.data"></sc-cloud-storage-banner-widget>
      }
      @case (widgetType.MiniBannerListWidget) {
        <sc-mini-banner-list-widget [data]="widget.data"></sc-mini-banner-list-widget>
      }
      @case (widgetType.MiniBannerWidget) {
        <sc-mini-banner-widget [data]="widget.data"></sc-mini-banner-widget>
      }
      @case (widgetType.MobileAppBannerWidget) {
        <sc-mobile-app-banner-widget [data]="widget.data"></sc-mobile-app-banner-widget>
      }      
    }
  </div>
}
